import { Box } from '@mui/material';
import { Suspense } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

const AccessRoleRoutes = ({ user, redirectTo = {} }) => {
  const { orgId } = useParams();

  return user?.isRoot || (user?.orgIds ?? []).indexOf(orgId) > -1 ? (
    <Box sx={{ minHeight: '250px', width: '100%' }}>
      <Suspense>
        <Outlet />
      </Suspense>
    </Box>
  ) : (
    <Navigate to={redirectTo} replace />
  );
};

export default AccessRoleRoutes;
